import { useEffect, useState } from 'react';

import { getPersistentId } from '@/modules/activityTracker/helpers';
import { GET_APP_LINK } from '@/modules/branch/constants';

export function useBranchAppLink() {
  const [branchAppLink, setBranchAppLink] = useState(GET_APP_LINK);

  useEffect(() => {
    async function initBranchAppLink() {
      const persistentId = await getPersistentId();
      const branchAppLink = `${GET_APP_LINK}?referrerPersistentIdentifier=${persistentId}`;

      if (persistentId) {
        setBranchAppLink(branchAppLink);
      }
    }
    initBranchAppLink();
  }, []);

  return branchAppLink;
}
